var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var PauseFilled72 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '72px' : _c, _d = _a.width, width = _d === void 0 ? '72px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 72 72", fill: "none", style: svgStyle },
            React.createElement("circle", { cx: 36, cy: 36, r: 36, fillOpacity: 0.7 }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.75 23V49.25H24V23H25.75Z", fill: "white", stroke: "white", strokeWidth: 2 }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48.5 23V49.25H46.75V23H48.5Z", fill: "white", stroke: "white", strokeWidth: 2 }))));
};
PauseFilled72.displayName = 'PauseFilled72';
export default PauseFilled72;
//# sourceMappingURL=pause-filled-72.js.map